module.exports = __webpack_public_path__ + "media/images/projet_02-ff4a497bf0b5a8de745b77c0fe00f40e.jpg";